import { GENES } from './common';

const MUTATION_RE = /([A-Za-z- 0-9]+):([A-Z\\*]+)([0-9]+)([A-Z\\*]*)( \(([A-Z]+)>([A-Z]+)\))?/;

export default class Mutation {
  constructor(name) {
    this.name = name;
    let match = name.match(MUTATION_RE);
    this.gene = match[1];
    this.position = parseInt(match[3]);
    this.refAA  = match[2].trim();
    this.geneSort = GENES.indexOf(this.gene);
    this.altAA = (match[4] || '').trim();
    this.refNuc = match[6];
    this.altNuc = match[7];
    this.label = name.split(':')[1];
    if (this.label.toUpperCase().indexOf('DEL') >= 0) {
      this.label = this.label.toUpperCase().replace(/^DEL/, '∆');
      this.isDeletion = true;
    }
    this.posLabel = this.refAA + this.position;
    let labelTokens = this.label.split(' ')
    if (labelTokens.length > 1) {
      this.label = labelTokens[0];
      let r = '',
        a = '',
        isMatching = false;
      for (let i = 0; i < 3; i++) {
        let nucsMatch = this.refNuc[i] === this.altNuc[i];
        if (nucsMatch) {
          if (!isMatching) {
            r += '<span class="matching text-color-3">';
            isMatching = true;
          }
        } else if (isMatching) {
          r += '</span>';
          isMatching = false;
        }
        r += this.refNuc[i];
      }
      if (!isMatching) {
        r += '<span class="matching text-color-3">';
        isMatching = true;
      }
      for (let i = 0; i < 3; i++) {
        let nucsMatch = this.refNuc[i] === this.altNuc[i];
        if (nucsMatch) {
          if (!isMatching) {
            a += '<span class="matching text-color-3">';
            isMatching = true;
          }
        } else if (isMatching) {
          a += '</span>';
          isMatching = false;
        }
        a += this.altNuc[i];
      }
      if (isMatching) {
        a += '</span>';
      }
      // this.nucLabel = labelTokens[1].replace('>','→');
      this.nucLabel = `<span class="text-color-3">(</span>${r}→${a}<span class="text-color-3">)</span>`;
    } else {
      this.nucLabel = '';
    }
  }

}
